/* eslint-disable  @typescript-eslint/no-non-null-assertion */
import { BasicPivotItem } from './pivotWorker.types';

// FIXME: this method needs to be cleaned up (types and logic)
export function buildFlatDataArr(pivotData: BasicPivotItem[], model?: any[], measure?: string): any[] {
  const flatDataArr: any[] = [];
  // This map will store whether an item, based on its *id*, has been created. If it has, it stores the location in
  // the flat data array.
  const defMap = {};
  const ignoreModelFlag = true;

  /**
   * Harvests all required data from the rawItem elements (the passed in object is a rawItem, if the children
   * property has an array of length zero) and adds a new flatItem to the flat data array if its *id* is not found
   * in the defMap, otherwise it updates the existing flatItem with the missing data provided by this rawItem.
   * @param {object} rawItem - The rawItem to harvest data from.
   */
  function getChildren(rawItem: BasicPivotItem) {
    let i, flatItem, prop, targetItem, splitName, name, value, current;
    if (typeof rawItem !== 'undefined' && typeof rawItem.children !== 'undefined' && rawItem.children.length > 0) {
      rawItem.children.forEach(function(child) {
        getChildren(child);
      });
    } else if (!defMap[rawItem.id]) {
      flatItem = {};
      defMap[rawItem.id] = flatDataArr.length;
      if (!ignoreModelFlag) {
        for (i = model!.length - 1; i >= 0; i -= 1) {
          current = model![i];
          name = current.name || current.dataIndex;
          splitName = name.split(':');
          if (splitName.length === 2) {
            prop = splitName[0];
            flatItem[prop + ':' + rawItem[prop]] = rawItem[measure!];
          } else {
            flatItem[name] = rawItem[name];
          }
        }
      } else {
        flatItem = rawItem;
      }
      flatDataArr.push(flatItem);
    } else if (defMap[rawItem.id] && !ignoreModelFlag) {
      targetItem = flatDataArr[defMap[rawItem.id]];
      for (i = model!.length - 1; i >= 0; i -= 1) {
        current = model![i];
        name = current.name || current.dataIndex;
        splitName = name.split(':');
        if (splitName.length === 2) {
          prop = splitName[0];
          targetItem[prop + ':' + rawItem[prop]] = rawItem[measure!];
        }
      }
    }
  }
  // The initial pivot data is not in the proper format, so we must run a forEach to begin the process.
  pivotData.forEach(function(child) {
    getChildren(child);
  });
  return flatDataArr;
}
